export function getValue(value) {
  return value ?? 0
}
